import { render, staticRenderFns } from "./ReserveRecord.vue?vue&type=template&id=fedc4340&scoped=true"
import script from "./ReserveRecord.vue?vue&type=script&lang=js"
export * from "./ReserveRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fedc4340",
  null
  
)

export default component.exports